<template>
    <router-view />
</template>
  
<style lang="scss">
  // Import Main styles for this application
  @import 'styles/style';
  @import '~bootstrap/scss/bootstrap';
  // @import '~bootstrap-icons/font/bootstrap-icons';
</style>
  